import { IResource } from "../i18n";

const translation_sr_latn: IResource = {
    header_title: 'MEET | sastanci bez muke',
    header_menu_api: 'API',
    header_signup_text: 'Besplatna registracija',
    header_signin_text: 'Prijava',
    header_dashboard_text: 'Moj Meet',

    general_title_text: 'Sastanci bez muke',
    general_cta_text_one: 'Uštedite vreme, novac i živce',
    general_cta_text_two: 'organizujući i održavajući',
    general_cta_text_three: 'intervjue preko interneta',
    general_cta_button: 'Besplatna proba',
    general_cta_contact: 'Kontakt email: office@meet.rs',
    general_tos_text: 'Uslove korišćenja',
    general_tos_tooltip: 'Vivani Meet uslovi korišćenja',
    general_cookies_text: 'Politiku internet kolačića',
    general_cookies_tooltip: 'Vivani Meet politika kolačića',
    general_privacy_text: 'Politiku privatnosti',
    general_privacy_tooltip: 'Vivani Meet politika privatnosti',
    general_refund_text: 'Uslove povraćaja novca',
    general_refund_tooltip: 'Vivani Meet politika povraćaja',

    general_cta_consent_one: 'Ovaj sajt  koristi kolačiće isključivo za analitiku i personalizaciju sadržaja.',
    general_cta_consent_two: 'Korišćenjem ovog sajta prihvatate',

    usecase_title_head: 'Planski napravljen za internet intervjue',
    usecase_title_subhead: 'Meet je dizajniran u potpunosti na bazi potreba poslodavca danas',
    usecase_interviewer_title: 'POMAŽE POSLODAVCU',
    usecase_interviewer_subtitle: 'Biblioteka zadataka',
    usecase_interviewer_body: 'Podesite zadatke intervjua unapred iz bibliteke zadataka',
    usecase_interviewer_learnmore: 'Naučite više',
    usecase_interviewer_imgalt: 'Whiteboard interview',
    usecase_collaboration_title: 'SARAĐUJTE NA ZADACIMA',
    usecase_collaboration_subtitle: 'Napravljen za saradnju',
    usecase_collaboration_body_one: 'Razgovarajte, kodirajte, crtajte, pišite ...',
    usecase_collaboration_body_two: 'Sve to zajedno i istovremeno',
    usecase_collaboration_learnmore: 'Naučite više',
    usecase_collaboration_imgalt: 'Whiteboard interview',    
    usecase_recruiter_title: 'POMAŽE REKRUTERIMA',
    usecase_recruiter_subtitle: 'Radi Vaš posao automatski',
    usecase_recruiter_body: 'Automatsko zakazivanje termina, hvatanje beleški, podsetnici učesnicima, prikupljanje povratnih infromacija...',
    usecase_recruiter_learnmore: 'Naučite više ',
    usecase_recruiter_imgalt: 'Whiteboard interview',    
    usecase_call_title: 'HD GRUPNI VIDEO POZIV',
    usecase_call_subtitle: 'Sa snimanjem i transkripcijom poziva',
    usecase_call_body_one: 'Bez ikakvih plaginova, aplikacija i instalacija.',
    usecase_call_body_two: 'Jednostavno radi na svom modernim browserima.',
    usecase_call_learnmore: 'Naučite više',
    usecase_call_imgalt: 'Whiteboard interview',  

    footer_email_text: "Kontakirajte nas",
    signout_menu_text: "Odjava",
    me_menu_text: "Moj Meet",
    
    help_menu_text: "Pomoć",

    cta_nosignup_text:  "Bez potrebe za nalogom i skidanjem aplikacija",
    
    // Change language
    language_selector_title: "Jezik",
    language_en_title: "English",
    language_es_title: "Español",
    language_srLatn_title: "Srpski",
    language_srCyrl_title: "Српски",
    language_fr_title: "Français",
    language_de_title: "Deutsch",
    language_it_title: "Italian",
    language_pl_title: "Polski",

    general_cta_button_quick: "Brzi sastanak",
    general_cta_text_all: "Uštedite vreme, novac i živce organizujući i održavajući intervjue preko interneta",

    header_title_short: "Vivani Meet",
}

export default translation_sr_latn;